export default {
  MOBILE: "mobile",
  TABLET: "tablet",
  IOS: "ios",
  DESKTOP: "desktop",
  ALL: "all"
};
